import React from "react";
import {Component} from "react";

import * as apiUtil from '../../../util/apiUtil';
import banner from '../component/img_fitness101.jpg';
import {aesEncrypt} from "../../../util/aes256";


/**
 * 250418 피트니스101 비즈팅 메시지 수신 이벤트 페이지
 * */
class Fitness101 extends Component {
    constructor(props) {
        super(props);

        this.scrollToCenter = this.scrollToCenter.bind(this);
        this.saveUserInfo = this.saveUserInfo.bind(this);


        this.eventUrlTest = this.eventUrlTest.bind(this);


        this.state = {};
    }

    componentDidMount() {
        if(sessionStorage.getItem('evt_sess') === 'init') this.saveUserInfo();

        // this.eventUrlTest();

        setTimeout(() => {
            this.scrollToCenter();
        }, 100);
    }



    scrollToCenter() {
        const scrollY = (document.documentElement.scrollHeight - window.innerHeight) / 2;
        window.scrollTo({ top: scrollY, behavior: 'smooth' });
    }


    eventUrlTest() {
        const encState = {
            eventCode: 'fitness101',
            type: 'NAVER',
            clientId: 'i8jRuVNstG953MdhMatH',
        }
        const state = encodeURIComponent(aesEncrypt(JSON.stringify(encState)));

        let url = `https://nid.naver.com/oauth2.0/authorize`;
        url += `?response_type=code`;
        url += `&client_id=i8jRuVNstG953MdhMatH`;
        // url += `&redirect_uri=http://172.16.0.99:3000/event`;
        url += `&redirect_uri=https://www.bizting.co.kr/event`;
        url += `&state=${state}`;

        // https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=i8jRuVNstG953MdhMatH&redirect_uri=http://172.16.0.99:3000/event&state=NpNoEC%2FTuVZPHk65NlQwWcTcbxHNy5yMObmgJwGQ%2FXW4rNYF2StT4h2bQfseLW12gFjV4DCLRYAWPABtfUHmU0%2F%2FIxZkJoBHT0FEkRUMV7ucLEcLvLFy%2FXGd7GwbiDoqqbPoKfSViUKGte2fmutOiQ%3D%3D
        // https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=i8jRuVNstG953MdhMatH&redirect_uri=https://www.bizting.co.kr/event&state=NpNoEC%2FTuVZPHk65NlQwWcTcbxHNy5yMObmgJwGQ%2FXW4rNYF2StT4h2bQfseLW12gFjV4DCLRYAWPABtfUHmU0%2F%2FIxZkJoBHT0FEkRUMV7ucLEcLvLFy%2FXGd7GwbiDoqqbPoKfSViUKGte2fmutOiQ%3D%3D
    }


    // 네이버 사용자 정보 저장
    saveUserInfo() {
        const { code, state } = this.props;

        apiUtil.asyncRequest({
            url: `/api/auth/naver/user?code=${code}&state=${state}`,
            method: apiUtil.requestMethod.POST,
            success: (res) => {
                sessionStorage.setItem('evt_sess', 'completed');
            }
        })

    }



    render() {
        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '50px'}}>

                <img src={banner} alt="fitness101.png" style={{
                    // height: '100vh', maxWidth: '100vw',
                    objectFit: 'contain', display: 'block'}} />

            </div>
        )
    }
}

export default Fitness101;
